import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GrupoService } from '@app/modules/grupo/services';
import { mergeMap } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';




@Component({
  selector: 'app-fast-grupo',
  templateUrl: './fast-grupo.component.html',
  styleUrls: ['./fast-grupo.component.scss'],
  providers: [GrupoService]
})
export class FastGrupoComponent implements OnInit {
  public form: UntypedFormGroup;

  loading = false;

  loadingCodigo = true;

  displayMessages = {
    parent_id: {
      typeIs: 'Grupo pai inválido.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    codigo: {
      required: 'O código é obrigatório',
      repeated: 'Este código já está em uso.',
      maxlength: 'O cóðigo deve conter no máximo 6 caracteres.'
    },
    nome: {
      required: 'O nome é obrigatório',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<FastGrupoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { is_parent: boolean },
    protected fb: UntypedFormBuilder,
    public entityService: GrupoService,
    public tokenService: TokenService,
    protected matSnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [null, [Validators.required, Validators.maxLength(60), CustomValidators.isEmptyValue()]],
      parent_id: [null, [CustomValidators.typeIs('object'), CustomValidators.isEmptyValue()]]
    });
  }

  /**
   * Faz a pesquisa no backend do grupo apartir do nome evitando
   * trazer os grupos que são filho
   * @param texto texto a ser buscado
   */
  public searchFn = (texto: string, include: string[], order_by: string[], page: number, page_size: number) =>
    this.entityService.getEntitiesByParams(
      {
        where: {
          nome: `%${texto}%`,
          domain_id: this.tokenService.getDomain().id,
          parent_id: null,
        },
        pagination:{
          page: page,
          page_size: page_size
        }
      },
      undefined,
      true
      // `nome=${texto}%&domain_id=${this.domainId}&parent_id=null`
    );

  public submit(): void {
    if (!this.form.valid) return;

    this.loading = true;
    const { parent_id, ...rest } = this.form.value;
    var entity = { domain_id: this.tokenService.getDomain().id, ...rest };

    entity.parent_id = parent_id ? parent_id.id : null;
    entity.parent = undefined;
    entity = Utils.trimAttributes(entity);
    this.entityService
      .insert(entity)
      .pipe(
        mergeMap(grp => {
          return this.entityService.getEntity(grp.id, ['parent']);
        })
      )
      .subscribe(
        grupo => {
          if (grupo) {
            this.matSnackBar.open(`Grupo cadastrado com sucesso.`,'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(grupo);
          }
        },
        () => {
          this.matSnackBar.open(`Erro ao cadastrar grupo.`,'X', {
            duration: 2000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['msg-error']
          });
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }
}
